import React, { useState } from "react";
import { Loader2, Sparkles, ArrowRight } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

function greet(h) {
  return h < 12 ? "Good morning" : h < 17 ? "Good afternoon" : "Good evening";
}

const period = (h) => (h < 12 ? "morning" : h < 17 ? "afternoon" : "evening");

export function DashboardTitle() {
  const { user } = useAuth();
  const first = (user?.name || user?.email || "there").split(" ")[0].split("@")[0];
  const today = new Date().toLocaleDateString("en-GB", { weekday: "long", day: "numeric", month: "long", year: "numeric" });
  const h = new Date().getHours();
  return (
    <div className="min-w-0 flex items-center gap-4" data-testid="dashboard-welcome">
      <img src={`/brand/illustrations/greet-${period(h)}.webp`} alt="" className="w-14 sm:w-16 h-auto shrink-0 select-none transition-[transform,filter] duration-300 ease-out hover:-translate-y-1 hover:scale-[1.04] hover:drop-shadow-[0_8px_10px_rgba(15,23,42,0.18)] motion-reduce:transition-none motion-reduce:hover:transform-none" data-testid={`welcome-icon-${period(h)}`} />
      <div className="min-w-0">
        <h1 className="text-3xl sm:text-4xl font-extrabold text-slate-900 tracking-tight" data-testid="welcome-greeting">{greet(h)}, {first}</h1>
        <p className="mt-1.5 text-sm sm:text-base text-slate-500" data-testid="welcome-date">{today} <span className="mx-2">·</span> Here's what's happening with your business today.</p>
      </div>
    </div>
  );
}

function AskBox() {
  const [q, setQ] = useState("");
  const ask = (e) => {
    e.preventDefault();
    const prompt = q.trim();
    if (!prompt) { return; }
    window.dispatchEvent(new CustomEvent("ted:open"));
    setTimeout(() => window.dispatchEvent(new CustomEvent("ted:prefill", { detail: { prompt, send: true } })), 350);
    setQ("");
  };
  return (
    <div className="lg:w-[46%] shrink-0 rounded-xl bg-slate-50 p-4 flex flex-col sm:flex-row sm:items-center gap-3" data-testid="briefing-ask">
      <p className="text-sm font-semibold text-slate-800 sm:pr-4 sm:border-r sm:border-slate-200 shrink-0">Need anything?</p>
      <form onSubmit={ask} className="flex-1 min-w-0">
        <p className="text-xs text-slate-500 mb-1.5">Ask Ted for a report, check stock, or find a job.</p>
        <div className="flex items-center gap-2 rounded-full bg-white border border-slate-200 pl-3 pr-1 py-1 focus-within:ring-2 focus-within:ring-indigo-200">
          <Sparkles className="w-4 h-4 text-indigo-500 shrink-0" />
          <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Ask a question…" className="flex-1 min-w-0 bg-transparent text-sm outline-none py-1" data-testid="briefing-ask-input" />
          <button type="submit" aria-label="Ask" disabled={!q.trim()} className="w-8 h-8 rounded-full bg-indigo-600 text-white flex items-center justify-center disabled:opacity-40 hover:bg-indigo-700 transition-colors" data-testid="briefing-ask-submit"><ArrowRight className="w-4 h-4" /></button>
        </div>
      </form>
    </div>
  );
}

export function BriefingStrip({ data, loading, tedEnabled }) {
  const h = new Date().getHours();
  const part = h < 12 ? "morning" : h < 17 ? "afternoon" : "evening";
  return (
    <section className="bg-white border border-slate-200 rounded-2xl shadow-sm p-4 sm:p-5 flex flex-col lg:flex-row gap-4 lg:items-center" data-testid="briefing-strip">
      <div className="flex gap-4 flex-1 min-w-0">
        <div className="min-w-0">
          <h2 className="text-base font-bold text-slate-900">AI {part} briefing</h2>
          <p className="mt-1 text-sm text-slate-600 leading-relaxed" data-testid="welcome-message">
            {loading ? <span className="inline-flex items-center gap-1.5"><Loader2 className="w-4 h-4 animate-spin" /> Getting your day ready…</span> : (data?.message || "Let's make today a good one.")}
          </p>
          {!loading && data?.inspiration && <p className="mt-1.5 text-xs italic text-slate-400" data-testid="welcome-inspiration">{data.inspiration}</p>}
        </div>
      </div>
      {tedEnabled && <AskBox />}
    </section>
  );
}
